<template>
    <p>Accettazione</p>
</template>

<script>
export default {};
</script>

<style></style>
